(() => {
  const SELECTORS = {
    root: '[data-rrtp-product]',
    productJson: '[data-rrtp-product-json]',
    choice: '[data-rrtp-variant-choice]',
    variantId: '[data-rrtp-variant-id]',
    price: '[data-rrtp-price]',
    comparePrice: '[data-rrtp-compare-price]',
    summary: '[data-rrtp-summary]',
    submit: '[data-rrtp-submit]',
    submitCopy: '[data-rrtp-submit-copy]',
    submitPrice: '[data-rrtp-submit-price]',
    mainImage: '[data-rrtp-main-image]',
    thumbnail: '[data-rrtp-thumbnail]',
  };

  const init = (root) => {
    if (root.dataset.rrtpInitialized === 'true') return;

    const jsonElement = root.querySelector(SELECTORS.productJson);
    if (!jsonElement) return;

    let product;
    try {
      product = JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.error('[REVIBRAS Mesas] No se pudo leer la información del producto.', error);
      return;
    }

    root.dataset.rrtpInitialized = 'true';

    const variants = product.variants || [];
    const variantInput = root.querySelector(SELECTORS.variantId);
    const price = root.querySelector(SELECTORS.price);
    const comparePrice = root.querySelector(SELECTORS.comparePrice);
    const summary = root.querySelector(SELECTORS.summary);
    const submit = root.querySelector(SELECTORS.submit);
    const submitCopy = root.querySelector(SELECTORS.submitCopy);
    const submitPrice = root.querySelector(SELECTORS.submitPrice);
    const mainImage = root.querySelector(SELECTORS.mainImage);
    const currency = product.currency || root.dataset.currency || 'CLP';
    const money = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency,
    });

    const formatMoney = (amount) => money.format((Number(amount) || 0) / 100);

    const findVariant = (id) => variants.find((variant) => String(variant.id) === String(id));

    const setActiveThumbnail = (imageUrl) => {
      root.querySelectorAll(SELECTORS.thumbnail).forEach((thumbnail) => {
        const isActive = Boolean(imageUrl && thumbnail.dataset.imageSrc === imageUrl);
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-pressed', String(isActive));
      });
    };

    const showVariantImage = (variant) => {
      if (!mainImage || !variant?.image || mainImage.src === variant.image) return;

      mainImage.classList.add('is-changing');
      mainImage.src = variant.image;
      mainImage.removeAttribute('srcset');
      mainImage.alt = variant.imageAlt || product.title || '';
      setActiveThumbnail(variant.image);
      requestAnimationFrame(() => mainImage.classList.remove('is-changing'));
    };

    const updateUrl = (variant) => {
      if (!variant || !window.history?.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    const update = (variant, { updateHistory = true } = {}) => {
      if (!variant) return;

      if (variantInput) {
        const changed = String(variantInput.value) !== String(variant.id);
        variantInput.value = variant.id;
        variantInput.disabled = false;
        if (changed) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (price) price.textContent = formatMoney(variant.price);

      const hasComparePrice = Number(variant.compareAtPrice) > Number(variant.price);
      if (comparePrice) {
        comparePrice.hidden = !hasComparePrice;
        comparePrice.textContent = hasComparePrice ? formatMoney(variant.compareAtPrice) : '';
      }

      if (summary) summary.textContent = variant.title || product.title;

      if (submit) {
        submit.disabled = !variant.available;
        submit.setAttribute('aria-disabled', String(!variant.available));
      }

      if (submitCopy) {
        submitCopy.textContent = variant.available ? root.dataset.buttonLabel : root.dataset.soldOutLabel;
      }

      if (submitPrice) {
        submitPrice.hidden = !variant.available;
        submitPrice.textContent = formatMoney(variant.price);
      }

      showVariantImage(variant);
      if (updateHistory) updateUrl(variant);
    };

    root.querySelectorAll(SELECTORS.choice).forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        update(findVariant(input.value));
      });
    });

    root.querySelectorAll(SELECTORS.thumbnail).forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage || !thumbnail.dataset.imageSrc) return;
        mainImage.classList.add('is-changing');
        mainImage.src = thumbnail.dataset.imageSrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumbnail.dataset.imageAlt || product.title || '';
        root.querySelectorAll(SELECTORS.thumbnail).forEach((item) => {
          const isActive = item === thumbnail;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
        requestAnimationFrame(() => mainImage.classList.remove('is-changing'));
      });
    });

    const initiallyChecked = root.querySelector(`${SELECTORS.choice}:checked`);
    const initialVariant = findVariant(initiallyChecked?.value || variantInput?.value) || variants[0];
    update(initialVariant, { updateHistory: false });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SELECTORS.root).forEach(init);
  };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
